var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgControlValve = function SvgControlValve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.857 21v-4.286L8 21V11l6.857 4.286V11h2.286v4.286L24 11v10l-6.857-4.286V21h-2.286",
    clipRule: "evenodd"
  })));
};
export { SvgControlValve as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M14.8571 21V16.7143L8 21V11L14.8571 15.2857V11H16H17.1429L17.1429 15.2857L24 11V21L17.1429 16.7143L17.1429 21L16 21H14.8571Z' fill='%234A6067'/%3e %3c/svg%3e";